if (!customElements.get('av-sticky-atc')) {
  customElements.define(
    'av-sticky-atc',
    class AvStickyAtc extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.sectionId;
        this.target = document.querySelector(this.dataset.buyButtonsTarget);
        this.variantIdInput = this.querySelector('.av-sticky-atc__variant-id');
        this.variantTitle = this.querySelector('.av-sticky-atc__variant');
        this.imageContainer = this.querySelector('.av-sticky-atc__image');
        this.submitButton = this.querySelector('.av-sticky-atc__submit');
        this.submitButtonText = this.submitButton?.querySelector('span');

        if (!this.target || !this.submitButton) {
          this.classList.add('av-sticky-atc--out');
          return;
        }

        this.observer = new IntersectionObserver(
          (entries) => {
            const entry = entries[0];
            const scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
            this.classList.toggle('av-sticky-atc--out', !scrolledPast);
          },
          { threshold: 0 }
        );
        this.observer.observe(this.target);

        this.onVariantChange = this.onVariantChange.bind(this);
        this.unsubscribeVariantChange = subscribe(PUB_SUB_EVENTS.variantChange, this.onVariantChange);
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.unsubscribeVariantChange?.();
      }

      onVariantChange(event) {
        if (event.data.sectionId !== this.sectionId) return;

        const variant = event.data.variant;

        if (this.variantIdInput) {
          this.variantIdInput.value = variant?.id ?? '';
          this.variantIdInput.disabled = !variant;
        }

        if (this.variantTitle && variant) {
          this.variantTitle.textContent = variant.public_title || variant.title || '';
        }

        if (this.imageContainer) {
          const src = variant?.featured_media?.preview_image?.src;
          if (src) {
            this.imageContainer.innerHTML = `<img src="${src}&width=100" alt="" loading="lazy" width="48" height="48">`;
            this.imageContainer.hidden = false;
          } else if (!variant) {
            this.imageContainer.hidden = true;
          }
        }

        if (this.submitButton && this.submitButtonText) {
          if (!variant) {
            this.submitButton.setAttribute('disabled', 'disabled');
            this.submitButtonText.textContent = window.variantStrings.unavailable;
          } else if (!variant.available) {
            this.submitButton.setAttribute('disabled', 'disabled');
            this.submitButtonText.textContent = window.variantStrings.soldOut;
          } else {
            this.submitButton.removeAttribute('disabled');
            this.submitButtonText.textContent = window.variantStrings.addToCart;
          }
        }
      }
    }
  );
}
